import React from 'react'

function Dashboard() {
  return (
    <div>
    hiiiiiiiiiiiiiiiiiiiiiiiiii
    </div>
  )
}

export default Dashboard
